<template>
    <!-- 收藏详情 -->
    <div :class="['detail', isDark ? 'dark' : '']">
      <div class="detail-title">{{ collectDtl.input }}</div>
      <div class="detail-content">
        <!-- {{ collectDtl.reply }} -->
        <div v-html="textContent"></div>
      </div>
      <div class="detail-time">{{ collectDtl.createdTime }}</div>
      <div class="detail-btn">
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-close"
          @click="toCollectDel(collectDtl)"
          >删除</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-copy-document"
          @click="copyByItem(null, collectDtl.reply)"
          >复制</el-button
        >
      </div>
    </div>
</template>

<script>
import api from "@/api";
import util from "@/utils/utils";
import { mapMutations, mapState } from 'vuex';
import { Marked } from "marked";
import { markedHighlight } from "marked-highlight";
import hljs from "highlight.js";

const marked = new Marked(
  markedHighlight({
    langPrefix: "hljs language-",
    highlight(code, lang, info) {
      const language = hljs.getLanguage(lang) ? lang : "plaintext";
      return hljs.highlight(code, { language }).value;
    },
  })
);

export default {
  name: 'CollectDtl',
  components: {},
  props: {
    collectDtl: {
      type: Object,
      default: {},
    },
  },
  data () {
    return {
      collectDel: api.collectDel,
    }
  },
  computed: {
    ...mapState('comAbout', ['isDark']),
    textContent: function() {
      let text = marked.parse(this.collectDtl.reply);
      text = this.formatMsg(text);
      return text;
    }
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    ...mapMutations('userAbout', ['deleteCollect']),
    //复制
    copyByItem(conversationId, text) {
      util.copyByItem([], this, conversationId, text);
    },
    //收藏删除
    toCollectDel(item, index) {
      this.$confirm("删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: this.isDark ? 'darkMessage' : '',
      })
        .then(() => {
          // this.loading = true;
          this.collectDel({ ConversationId: item.conversationId })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: `已删除`,
                  type: "success",
                });
                this.$emit('closeDtl');
                this.deleteCollect(item.conversationId);
              } else {
                this.$message.error("删除失败：" + res.message);
              }
              // this.loading = false;
            })
            .catch((e) => {
              // this.loading = false;
            });
        })
    },
        /** 处理显示内容格式
     * msgStr  marked转化后的html
     */
     formatMsg(htmlText) {
      console.log("htmlText", htmlText);
      // return htmlText
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlText;
      console.log("tempDiv", tempDiv);
      // 遍历tempDiv的所有子节点，并移除不在<pre>标签内的换行符
      var children = tempDiv.childNodes;
      // console.log('--children', children)
      var output = "";
      for (var i = 0; i < children.length; i++) {
        var node = children[i];
        if (node.nodeType === 3) {
          if (node.nodeValue !== "\n") {
            output += node.nodeValue;
          }
        } else if (node.tagName.toLowerCase() === "pre") {
          output += node.outerHTML;
        } else {
          output += node.outerHTML.replace(/\r?\n/g, "");
        }
      }

      // console.log('最后--', output)
      return output;
    },
  }
}
</script>

<style scoped lang="less">
.detail {
  border: 1px solid #edeff0;
  border-radius: 4px;
  padding: 24px;

  .detail-title {
    color: #333333;
    font-size: 16px;
    line-height: 16px;
  }
  .detail-content {
    color: #555555;
    font-size: 14px;
    line-height: 24px;
    margin: 24px 0;
    white-space: pre-wrap;
  }
  .detail-time {
    width: 100%;
    color: #666666;
    font-size: 14px;
    line-height: 14px;
    text-align: right;
    margin-bottom: 24px;
  }
  .detail-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
@media (max-width: 750px) {
  .detail {
    border: none;
    border-radius: 0;
    padding: 0;
  }
}

// 暗黑模式
.dark {
  border-color: #1a2236;
  .detail-title {
    color: #fff;
    line-height: 20px;
  }
  .detail-content, .detail-time {
    color: #aaa;
  }
}
</style>
